import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { FaFileAlt, FaGithubAlt, FaInbox, FaLinkedinIn, FaPassport } from "react-icons/fa";
import "./OnlineResume.css";
const OnlineResume = () => {

  useEffect(() => {
    Aos.init({ duration: 2500 });
  }, []);


  return (
    <div className="container px-10 mx-auto mb-20">

    <div  data-aos="fade-down" className="flex justify-center pb-8">
    <h1 className="py-1 sm:font-xl md:text-2xl lg:text-2xlbold sm:text flex">
                  <FaFileAlt className=" px-1 text-indigo-700  sm:text-xl md:text-4xl lg:text-4xl" />
                  Online Resume
                </h1>
    </div>

      <div  data-aos="fade-up" className="card bg-green-100 border border-gray-300 rounded">
        <div className="px-6 py-10">
          <div className="border-b-2 border-gray-300 flex justify-between">
            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
              <div>
                <img
                  src="/img/Pro Pic small.jpg"
                  className="pr-7 h-48 w-48 object-contain"
                  alt=""
                />

                <h1 className="font-bold text-gray-900  text-5xl md:text-5xl lg:text-5xl">
                  RIAN <br />
                  ISLAM
                </h1>
                <p className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                  Software Engineer
                </p>
              </div>

              <div className="">
                <h1>
                  <li className="font--xl md:text-2xl lg:text-2xlbold sm:text">
                    Professional Summary
                  </li>
                </h1>
                <p>
                  I am a front-end developer and Curious about Web Application
                  Development & Security. I like to work with javascript and its
                  framework(React, Nuxtjs) and having experience in Back-End
                  Technology Nodejs , MongoDB. I always like to learn about
                  trending technologies.
                </p>
                <h1 className="pt-2">
                  <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                    Contact Details
                  </li>
                </h1>

                <p className="py-1 text-sm font-bold flex">
                  <FaInbox className=" px-1 text-indigo-500  sm:text-xl md:text-xl lg:text-xl" />
                  rianislamrian@gmail.com
                </p>
                <p className="py-1 text-sm font-bold flex">
                  <FaGithubAlt className=" px-1 text-gray-500  sm:text-xl md:text-xl lg:text-xl" />
                  <a target="_blank" href="https://github.com/mdrianislam0or1" rel="noreferrer">
                    https://github.com/mdrianislam0or1
                  </a>
                </p>
                <p className="py-1 text-sm font-bold flex">
                  <FaLinkedinIn className=" px-1 text-blue-700  sm:text-xl md:text-xl lg:text-xl" />
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/mdrianislam0or1/" rel="noreferrer"
                  >
                    https://www.linkedin.com/in/mdrianislam0or1
                  </a>
                </p>
                <p className="py-1 text-sm font-bold flex">
                  <FaPassport className=" px-1 text-green-500  sm:text-xl md:text-xl lg:text-xl" />
                  <a target="_blank" href="https://rianislam-me.web.app/" rel="noreferrer">
                    https://rianislam-me.web.app
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="border-b-2 border-gray-300 flex justify-between">
            {/* Education part  skills part*/}

            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
              <div className="  border-r-3  border-gray-300 pr-10">
                <h1 className="pt-4">
                  <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                    Skills and Abilities
                  </li>
                </h1>
                <div className="py-3">
                  <p>- Programming Language: C, C++, Javascript, Python</p>
                  <p>
                    - Libraries & Frameworks: React, Redux, Express, Tailwind,
                    Bootstrap, etc
                  </p>
                  <p>- Dev Tools: Firebase, Git, Github, Heroku</p>
                  <p>
                    - Design Tools: Adobe Illustrator, Adobe Photoshop, Adobe Xd
                  </p>

                  <p>- Databases: MongoDB</p>
                </div>
              </div>

              <div className="">
                <h1 className="pt-4">
                  <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                    Academic Profile
                  </li>
                </h1>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      Mymensingh Engineering College
                    </li>
                  </h1>
                  <p>BSC in Computer Science & Engineering</p>
                  <p>2019 - Present</p>

                  <p>
                    <li>
                      In my academic education, I have studied in basic C,
                      C++and JAVA language
                    </li>
                  </p>
                  <p>
                    <li>
                      I have studied basic software engineering subjects like
                      DS, Algorithms, OOP, etc.
                    </li>
                  </p>
                </div>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      Govt. Edward College, Pabna
                    </li>
                  </h1>
                  <p>Higher Secondary Education</p>
                  <p>2016 - 2018</p>

                  <p>
                    <li>I passed my HSC exam and got GPA5</li>
                  </p>
                </div>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      Pabna Zilla School,Pabna
                    </li>
                  </h1>
                  <p>Secondary School Certificate</p>
                  <p>2007 - 2016</p>

                  <p>
                    <li>I passed my SSC exam and got GPA5</li>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="border-b-2 border-gray-300 flex justify-between">
            {/* core part  projects part*/}

            <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
              <div className="  border-r-3  border-gray-300 pr-10">
                <h1 className="pt-4">
                  <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                  Core Competencies
                                    </li>
                </h1>
                <div className="py-3">
                  <p>- Mind Mapping and Structured Thinking</p>
                  <p>
                  - Collaborative Working
                  </p>
                  <p>- Making Decisions and can motivate others</p>
                  <p>
                  - Creative thinking
                  </p>

                  <p>- Ability to effectively work with others</p>
                  <p>- Trustworthiness</p>
                </div>
              </div>

              <div className="">
                <h1 className="pt-4">
                  <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                    Projects
                  </li>
                </h1>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      AVENTADOR(Team-Project)
                    </li>
                  </h1>
                  <p>We created this site inspired by Tesla</p>
                  <p>(Created on 2021-05-30)</p>

                  <p>
                    <li>Here Redux is used to manage the state</li>
                  </p>
                  <p>
                    <li>Here the styled-components is used for design</li>
                  </p>
                  <p>
                    <li>
                      Technology: Reactjs,React-Router,Redux,Styled-Components.
                    </li>
                  </p>
                  <p>
                    <li>
                      <a target="_blank" href="https://aventador-s-l.web.app" rel="noreferrer">
                        Live Link
                      </a>
                    </li>
                  </p>
                  <p>
                    <li>
                      <a
                        target="_blank"
                        href="https://github.com/RianIslam/team-work" rel="noreferrer"
                      >
                        {" "}
                        Code Link
                      </a>
                    </li>
                  </p>
                </div>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      Tech Software
                    </li>
                  </h1>

                  <p>(Created on 2021-04-15)</p>

                  <p>
                    <li>Repair center website.</li>
                  </p>
                  <p>
                    <li>Users can take service and give feedback.</li>
                  </p>
                  <p>
                    <li>Admin can manage services.</li>
                  </p>
                  <p>
                    <li>
                      Technology: Reactjs, Firebase for authentication, Node js,
                      Express js, MongoDB
                    </li>
                  </p>
                  <p>
                    <li>
                      <a
                        href="https://repair-items.web.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Live Link
                      </a>
                    </li>
                  </p>
                  <p>
                    <li>
                      <a
                        href="https://github.com/RianIslam/TechSoftware"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Code Link
                      </a>
                    </li>
                  </p>
                </div>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      Bike Hub
                    </li>
                  </h1>
                  <p>(Created on 2021-03-31)</p>

                  <p>
                    <li>Bike showroom website.</li>
                  </p>
                  <p>
                    <li>Users can show details about the bike.</li>
                  </p>
                  <p>
                    <li>
                      Users can order the bike and show their own order list.
                    </li>
                  </p>
                  <p>
                    <li>
                      Technology: Reactjs, Firebase for authentication, Node js,
                      Express js, MongoDB
                    </li>
                  </p>

                  <p>
                    <li>
                      <a
                        href="https://bike-zone-franz.web.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Live Link
                      </a>
                    </li>
                  </p>
                  <p>
                    <li>
                      <a
                        href="https://github.com/RianIslam/BikeHub"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Code Link
                      </a>
                    </li>
                  </p>
                </div>

                <div className="p-1">
                  <h1 className="pt-2">
                    <li className="font-bold sm:text-xl md:text-2xl lg:text-2xl">
                      Road King Rider
                    </li>
                  </h1>
                  <p>(Created on 2021-03-18)</p>

                  <p>
                    <li>User can choose their option and Use it to move.</li>
                  </p>
                  <p>
                    <li>Load data using fake API.</li>
                  </p>
                  <p>
                    <li>The Simple react-router website.</li>
                  </p>
                  <p>
                    <li>
                      Technology: Reactjs, Firebase for authentication,
                      React-Router.
                    </li>
                  </p>

                  <p>
                    <li>
                      <a
                        href="https://react-auth-rianislam.web.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Live Link
                      </a>
                    </li>
                  </p>
                  <p>
                    <li>
                      <a
                        href="https://github.com/RianIslam/Road-King"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Code Link
                      </a>
                    </li>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlineResume;
